"use strict";
import simpleModal from "../libs/simpleModal";

export default async function () {
    const infoModal = new simpleModal({id: 'restrictedAuth', small: true});
    await infoModal.loadContent({
        url: '/site/communities/messages',
        data: {
            cid: window.cid,
            name: "user_pending_approval"
        }
    });
}
